import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from '../BaseComponent';

const Checkbox = ({
  classNameValue,
  buttonName,
  checked,
  onChange,
  name,
  value,
  id,
  disabled,
}) => {
  const handleOnChange = (e) => {
    !!onChange && onChange(e);
  };
  return (
    <BaseComponent name={'Checkbox'}>
      <div className={`checkbox-input  ${classNameValue ? classNameValue : ''} `}>
        <label>
          <input
            type="checkbox"
            name={name}
            value={value}
            className="mr-3"
            checked={checked}
            onChange={handleOnChange}
            id={id}
            disabled={disabled}
          />
          {buttonName}
        </label>
      </div>
    </BaseComponent>
  );
};

Checkbox.propTypes = {
  classNameValue: PropTypes.string,
  buttonName: PropTypes.string,
  checked: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export { Checkbox };
